/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/StrategyDescriptionParticipator'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/StrategyDescriptionParticipator'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.StrategyDescriptionParticipatorApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.StrategyDescriptionParticipator);
  }
}(this, function(ApiClient, StrategyDescriptionParticipator) {
  'use strict';

  /**
   * StrategyDescriptionParticipator service.
   * @module api/StrategyDescriptionParticipatorApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new StrategyDescriptionParticipatorApi. 
   * @alias module:api/StrategyDescriptionParticipatorApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the strategyDescriptionParticipatorAddAllPut operation.
     * @callback module:api/StrategyDescriptionParticipatorApi~strategyDescriptionParticipatorAddAllPutCallback
     * @param {String} error Error message, if any.
     * @param {Array.<'Integer'>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * addAll
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/StrategyDescriptionParticipator>} body 
     * @param {module:api/StrategyDescriptionParticipatorApi~strategyDescriptionParticipatorAddAllPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<'Integer'>}
     */
    this.strategyDescriptionParticipatorAddAllPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling strategyDescriptionParticipatorAddAllPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling strategyDescriptionParticipatorAddAllPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = ['Integer'];

      return this.apiClient.callApi(
        '/StrategyDescriptionParticipator/addAll', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the strategyDescriptionParticipatorDeleteAllPut operation.
     * @callback module:api/StrategyDescriptionParticipatorApi~strategyDescriptionParticipatorDeleteAllPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * deleteAll
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/Integer>} body 
     * @param {module:api/StrategyDescriptionParticipatorApi~strategyDescriptionParticipatorDeleteAllPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.strategyDescriptionParticipatorDeleteAllPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling strategyDescriptionParticipatorDeleteAllPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling strategyDescriptionParticipatorDeleteAllPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/StrategyDescriptionParticipator/deleteAll', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the strategyDescriptionParticipatorInviteUsersPut operation.
     * @callback module:api/StrategyDescriptionParticipatorApi~strategyDescriptionParticipatorInviteUsersPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * inviteUsers
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/Integer>} body 
     * @param {Integer} strategyID 
     * @param {Integer} invitationType 
     * @param {String} coverLetter 
     * @param {module:api/StrategyDescriptionParticipatorApi~strategyDescriptionParticipatorInviteUsersPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.strategyDescriptionParticipatorInviteUsersPut = function(_4SAPIAppID, body, strategyID, invitationType, coverLetter, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling strategyDescriptionParticipatorInviteUsersPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling strategyDescriptionParticipatorInviteUsersPut";
      }

      // verify the required parameter 'strategyID' is set
      if (strategyID == undefined || strategyID == null) {
        throw "Missing the required parameter 'strategyID' when calling strategyDescriptionParticipatorInviteUsersPut";
      }

      // verify the required parameter 'invitationType' is set
      if (invitationType == undefined || invitationType == null) {
        throw "Missing the required parameter 'invitationType' when calling strategyDescriptionParticipatorInviteUsersPut";
      }

      // verify the required parameter 'coverLetter' is set
      if (coverLetter == undefined || coverLetter == null) {
        throw "Missing the required parameter 'coverLetter' when calling strategyDescriptionParticipatorInviteUsersPut";
      }


      var pathParams = {
      };
      var queryParams = {
        'strategyID': strategyID,
        'invitationType': invitationType,
        'coverLetter': coverLetter
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/StrategyDescriptionParticipator/inviteUsers', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
